import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import ViewSectionName from "./view-section-name";
import ViewDividerSmall from "./view-divider-sm";
import WebbLoader from "./webb-loader";

import VaultDocsOverview from "./vault-docs-overview";
import VaultDocsTransactions from "./vault-docs-trxn";

import { GetAuthUser } from "../services/user-accounts";
import { GetUserDocsDetail } from "../services/user-vault";


const stat = [
  {code:"Pending", colr:"warning"},
  {code:"Active", colr:"success"},
  {code:"Expired", colr:"danger"},
  {code:"Inactive", colr:"lite"},
]

export default function VaultDocsDetailModule() {

  const asset = GetAuthUser();
  const { id } = useParams();

  const [loading,setLoading]=useState(true);
  const [data,setData]=useState({});

  useEffect( () => {
    if (asset){
      const fetchData = async() => {
        setLoading(true);

        setData( (await GetUserDocsDetail(JSON.stringify({
          body: {crid: id, usid: asset.usid, form: asset.form},
          user: {usid: asset.usid, form: asset.form}
        }))).data)

        setLoading(false);
      }
      fetchData()
    } else {}
  },[asset.usid]);

  if (loading)
  return (<> <WebbLoader /> </>)

  return (
    <>
    <div className="">

      <VaultDocsOverview data={data} />
      
      <div className="mb-3"></div>
      <ViewSectionName data={'Records'} />
      <VaultDocsTransactions />
      
    </div>
    </>
  )
}